<nb-card class="offer-status">
  <nb-card-header>
    <h4>{{ "pages.admin.pricing.offers.statusDialog.title" | translate: { name: name } }}</h4>
  </nb-card-header>
  <nb-card-body>
    <span class="label">{{ "pages.admin.pricing.offers.statusDialog.status" | translate }}</span>
    <app-segmented-control
      class="offer-status__switch"
      [options]="options"
      [value]="status"
      (valueChange)="setStatus($event)"
      [ariaLabel]="'pages.admin.pricing.offers.statusDialog.status' | translate"
    ></app-segmented-control>

    <label class="label" for="offer-status-reason">{{ "pages.admin.pricing.offers.statusDialog.reason" | translate }}</label>
    <textarea
      id="offer-status-reason"
      nbInput
      fullWidth
      rows="3"
      maxlength="4000"
      [(ngModel)]="reason"
      [placeholder]="'pages.admin.pricing.offers.statusDialog.reasonPlaceholder.' + status | translate"
    ></textarea>

    @if (entries.length) {
      <span class="label offer-status__history-label">{{ "pages.admin.pricing.offers.statusDialog.history" | translate }}</span>
      <ul class="offer-status__history">
        @for (e of entries; track $index) {
          <li>
            <span class="al-status-chip" [ngClass]="'al-status-chip--' + tone(e.status)">
              {{ "pages.admin.pricing.offers.status." + e.status | translate }}
            </span>
            <span class="offer-status__meta">{{ e.at | date: "dd.MM.yyyy HH:mm" }} · {{ e.by_name || "—" }}</span>
            @if (e.reason) {
              <p class="offer-status__reason">{{ e.reason }}</p>
            }
          </li>
        }
      </ul>
    }
  </nb-card-body>
  <nb-card-footer>
    <button type="button" nbButton status="danger" outline (click)="dialogRef.close()">
      {{ "buttons.cancel" | translate }}
    </button>
    <button type="button" nbButton status="primary" (click)="save()">
      {{ "buttons.save" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
